import React from "react";

// Purple "LIVE" tag for patients with Confirmation "Live" (remote / live
// monitoring). They go through the normal steps, listed on /live-patients
// instead of the Holter Patient List; this tag marks them on every page.
const LiveTag = ({ style }) => (
  <span
    title="Live / remote monitoring patient (Confirmation: Live)"
    style={{
      display: "inline-block",
      marginTop: 3,
      marginLeft: 4,
      fontSize: "10px",
      fontWeight: 700,
      color: "#fff",
      background: "#8e44ad",
      borderRadius: 10,
      padding: "1px 8px",
      letterSpacing: "0.5px",
      verticalAlign: "middle",
      ...style,
    }}
  >
    <span role="img" aria-label="live">📡</span> LIVE
  </span>
);

export default LiveTag;
